import { parseISO } from 'date-fns'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'

function isExpired (dateSigned) {
  if (!dateSigned) {
    return false
  }
  const parsedDate = parseISO(dateSigned)
  // Handle the eSignature saving and invalidating if old, and TOS
  // 30 days
  let EXPIRATION_TIME = 30 * 24 * 60 * 60 * 1000
  return (new Date() - parsedDate) > EXPIRATION_TIME
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  const rootStore = useRootStore()
  const borrowerStore = useBorrowerStore()
  const isEmbeddedRoute = to.path.includes('/embedded')
  const embeddedCheck = rootStore.isEmbedded || isEmbeddedRoute

  // Only check for logged-in users or embedded routes
  if (!rootStore.isLoggedIn && !embeddedCheck) {
    return
  }

  // Do NOT block the render by waiting for these results
  // Run this asynchronously without awaiting
  borrowerStore.getBorrowerValues().then(borrowerValues => {
    if (!borrowerValues) return
    const dateSigned = borrowerValues['date_signed'].value
    const ipAddress = borrowerValues['ip_address'].value
    const missingIpOrDate = !ipAddress || !dateSigned
    if (missingIpOrDate || isExpired(dateSigned)) {
      borrowerStore.$patch({ signatureExpired: true })
    }
  }).catch(() => {
    // Silently fail - don't block navigation
  })
})

